<template>
    <div class="field children-fields">
        <label class="label">注文で選べるお子さま（任意）</label>
        <p class="help">兄弟のお名前を登録すると、注文ごとに1人を選べます。登録・選択は必須ではありません。</p>
        <div v-for="(child, index) in value" :key="child.id || 'new-' + index" class="child-row">
            <input class="input" type="text" :value="child.name" maxlength="100" :aria-label="'お子さま' + (index + 1) + 'の学年・組・氏名'" placeholder="2年3組 見本太郎" @input="rename(index, $event.target.value)">
            <button type="button" class="button is-light" @click="remove(index)">削除</button>
        </div>
        <button type="button" class="button is-small is-info" :disabled="value.length >= 20" @click="add">お子さまの登録欄を追加</button>
    </div>
</template>

<script>
export default {
    props: { value: { type: Array, default: () => [] } },
    methods: {
        add () { this.$emit('input', this.value.concat({ id: '', name: '' })) },
        remove (index) { this.$emit('input', this.value.filter((child, i) => i !== index)) },
        rename (index, name) { this.$emit('input', this.value.map((child, i) => i === index ? { ...child, name } : child)) }
    }
}
</script>

<style scoped>
.child-row { display: flex; gap: 8px; margin: 8px 0; }
.child-row .input { min-width: 0; }
.children-fields > .button { margin-top: 8px; }
</style>



// WEBPACK FOOTER //
// src/components/photobuy/ChildrenFields.vue